import { gql } from '@apollo/client';

export const FETCH_ACCESSIBLE_SITES = gql`
    query fetchAccessibleSites {
        system {
            companies {
                id
                alias
                name
                facilities {
                    id
                    alias
                    name
                    description
                    windowsTimezone
                    ianaTimezone
                    passwordResetFrequencyDays
                    smaxCustomerCode
                    salesForceAccountId
                    smaxStaleDataTimeoutSeconds
                    facilityCode
                    latitude
                    longitude
                    region
                    defaultZoomLevel
                    type
                    processDataRetentionInDays
                    isActive
                    useImperialUnits
                }
            }
        }
    }
`;
